// extracted by mini-css-extract-plugin
module.exports = {"fondo":"Home2__fondo__1cfRw","indices":"Home2__indices__1elwV"};